module.exports = __webpack_public_path__ + "static/img/highVacuumDownload.4c75a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/highVacuumDownload.png
// module id = uhTc
// module chunks = 1